import Vue from 'vue';
import BurgerMenu from "../BurgerMenu/BurgerMenu.vue";
var initializeBurgerMenu = function () {
    var mountEl = document.querySelector('c-burger-menu');
    if (mountEl) {
        new Vue({
            props: ['navPrimaryJSON', 'navTlt', 'satelliteMobileJSON', 'countriesJSON', 'countryHeadline'],
            render: function (createElement) {
                var context = {
                    props: {
                        navPrimaryJSON: mountEl.dataset.navPrimary,
                        navTlt: mountEl.dataset.navTlt,
                        satelliteMobileJSON: mountEl.dataset.satelliteMobile,
                        countriesJSON: mountEl.dataset.countries,
                        countryHeadline: mountEl.dataset.countryHeadline
                    },
                };
                return createElement(BurgerMenu, context);
            }
        }).$mount('c-burger-menu');
    }
};
export default initializeBurgerMenu;
